import axios from "axios";
import baseURL from "./../api";
class CashoutService {

    getCashout() {
        return axios.get(`${baseURL}/batch/payout`);
    }

    createBatch(data) {
        return axios.post(`${baseURL}/batch/payout`,data);
    }
    getPaymentMethods() {
        return axios.get(`${baseURL}/config/drop-down/payment-submethods`);
    }
    downloadBatchfile(batchId) {
        return axios.get(`${baseURL}/batch/payout/${batchId}/file/download`);
    }
    batchDetails(batchId) {
        return axios.get(`${baseURL}/batch/payout/${batchId}`);
    }
    uploadBatch(batchId,data) {
        return axios.post(`${baseURL}/batch/payout/${batchId}/file/upload`,data);

    }
   
}
export default new CashoutService();